import React, { useEffect, useState } from 'react';
import AdminAssets from './AdminAssets';
import AdminSidebar from './AdminSidebar';
import axios from '../../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';

const AdminRecruiters = () => {
  const [recruiters, setRecruiters] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`, {
  //     withCredentials: true,
  //   }).then(() => {
  //     setLoading(false);
  //     fetchRecruiters();
  //   }).catch(() => {
  //     navigate('/admin');
  //   });
  // }, [navigate]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`)
      .then((res) => {
        if (!res.data.loggedIn) {
          navigate('/admin');
        } else {
          setLoading(false);
          fetchRecruiters();
        }
      })
      .catch(() => {
        navigate('/admin');
      });
  }, [navigate]);



  const fetchRecruiters = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/recruiters`);
      setRecruiters(response.data);
    } catch (error) {
      console.error('Error fetching recruiters:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this recruiter?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE}/recruiters/${id}`);
        setRecruiters((prev) => prev.filter((e) => e._id !== id));
        window.location.reload();
      } catch (error) {
        console.error('Failed to delete recruiter:', error);
      }
    }
  };

  const handleExport = () => {
    const exportData = recruiters.map(({ createdAt, name, company, email, contact, designation }) => ({
      Date: new Date(createdAt).toLocaleDateString(),
      Name: name,
      Company: company,
      Email: email,
      Contact: contact,
      Designation: designation,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Recruiters');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'recruiters.xlsx');
  };

  // Initialize DataTable after recruiters are rendered
  useEffect(() => {
    if (!loading && recruiters.length > 0) {
      const timeout = setTimeout(() => {
        $('#recruiterTable').DataTable({
          destroy: true,
          initComplete: function () {
            this.api().columns().every(function () {
              const that = this;
              $('input', this.header()).off().on('input', function () {
                that.search(this.value).draw();
              });
            });
          }
        });
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [loading, recruiters]);

  if (loading) return null;

  return (
    <div>
      <AdminAssets />
      <AdminSidebar />

      <section className="content">
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="card">
                <div className="header d-flex justify-content-between align-items-center">
                  <h2 className="fw-bold text-start">Recruiters</h2>
                  <button className="btn btn-success" onClick={handleExport}>
                    Export to Excel
                  </button>
                </div>
                <div className="body">
                  {recruiters.length === 0 ? (
                    <p>No recruiters found.</p>
                  ) : (
                    <div className="table-responsive">
                      <table id="recruiterTable" className="table table-bordered table-striped table-hover display w-100">
                        <thead>
                          <tr>
                            <th>Action</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Company</th>
                            <th>Email</th>
                            <th>Contact</th>
                            <th>Designation</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th><input type="text" placeholder="Search Date" /></th>
                            <th><input type="text" placeholder="Search Name" /></th>
                            <th><input type="text" placeholder="Search Company" /></th>
                            <th><input type="text" placeholder="Search Email" /></th>
                            <th><input type="text" placeholder="Search Contact" /></th>
                            <th><input type="text" placeholder="Search Designation" /></th>
                          </tr>
                        </thead>
                        <tbody>
                          {recruiters.map((recruiter) => (
                            <tr key={recruiter._id}>
                              <td>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(recruiter._id)}>
                                  Delete
                                </button>
                              </td>
                              <td>{new Date(recruiter.createdAt).toLocaleDateString()}</td>
                              <td>{recruiter.name}</td>
                              <td>{recruiter.company}</td>
                              <td>{recruiter.email}</td>
                              <td>{recruiter.contact}</td>
                              <td>{recruiter.designation}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminRecruiters;
